import { Language } from '@/features/auth'

export const salutations = ['mr', 'ms', 'non-binary'] as const

export type Salutation = (typeof salutations)[number]

export const isValidSalutation = (salutation: string): salutation is Salutation =>
  salutations.some((item) => item === salutation)

export const roles = ['admin', 'manager', 'billing', 'purchaseOrderOperator'] as const

export type UserRole = (typeof roles)[number]

export const isValidRole = (role: string): role is UserRole => roles.some((item) => item === role)

// @TODO Check if we can re-use the user type from auth here and whether it's really reliably 100% the same
export type User = {
  _id: string
  salutation?: Salutation
  firstName: string
  lastName: string
  email: string
  phoneMobile?: string
  phoneLandline?: string
  customer_id: string
  isBilling: boolean
  roles: UserRole[]
  languages: Language[]
  organizationId: string
  preferredLanguage: Language
  title: string
  registeredAt?: string
}
